export default __webpack_public_path__ + "static/media/ms.d38cb04f.png";